import styled from 'styled-components';
import DefaultButton from './DefaultButton';
import { IDefaultButtonProps } from './types';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';

const DangerButton = styled(DefaultButton)<IDefaultButtonProps>`
  --button-bg-c: ${colors.disableButton};
  --button-text-c: ${theme.colors.white};
  --button-text-hover-c: ${theme.colors.white};
  --button-bg-hover-c: ${colors.disableButton};
`;

export default DangerButton;
